import React from 'react';

const PlusIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        style={{ cursor: 'pointer' }}
    >
        <path
            d="M12 4.58594V20.5859M20 12.5859L4 12.5859"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default PlusIcon;